import React, { useEffect, useState } from 'react'

import Button from 'components_new/atoms/Button'

import NewSettingsItem from 'components_new/molecules/NewSettingsItem'

import ChartOfAccounts from 'components_new/organisms/economy/ChartOfAccounts'
import EconomyAccountingPeriod from 'components_new/organisms/economy/EconomyAccountingPeriod'
import EconomyAccountLevels from 'components_new/organisms/economy/EconomyAccountLevels'
import EconomyCustomMetrics from 'components_new/organisms/economy/EconomyCustomMetrics'

import SettingsTemplate from 'components_new/templates/SettingsTemplate'

import { useCompanyActions } from 'redux/actions/Companies'
import { useKpiVariableOptionActions } from 'redux/actions/KpiVariableOptions'
import { useEconomySetActions } from 'redux/actions/EconomySets'

import {
  useEconomySets,
  useShouldFetchEconomySets
} from 'redux/hooks/EconomySets'
import { useShouldFetchKpiVariableOptions } from 'redux/hooks/KpiVariableOptions'
import { useShouldFetchCompanies } from 'redux/hooks/Companies'
import { useTranslation } from 'language/translator'
import { useCustomKpis } from 'redux/hooks/Metrics'

const EconomyPage = () => {
  const { t } = useTranslation()

  // Getters
  const { tryGetAllCompanies } = useCompanyActions()
  const { tryGetAllEconomySets } = useEconomySetActions()
  const { tryGetAllKpiVariableOptions } = useKpiVariableOptionActions()

  // Fetch booleans
  const fetchKpiVariableOptions = useShouldFetchKpiVariableOptions()
  const fetchEconomySets = useShouldFetchEconomySets()
  const fetchCompanies = useShouldFetchCompanies()

  useEffect(() => {
    if (fetchEconomySets) {
      tryGetAllEconomySets()
    }

    if (fetchKpiVariableOptions) {
      tryGetAllKpiVariableOptions()
    }

    if (fetchCompanies) {
      tryGetAllCompanies()
    }
  }, [
    fetchEconomySets,
    fetchKpiVariableOptions,
    fetchCompanies
  ])

  const [customKpis] = useCustomKpis()
  const [economySets] = useEconomySets()

  const [showMetrics, setShowMetrics] = useState<boolean>(false)
  const [showEconomySets, setShowEconomySets] = useState<boolean>(false)

  return (
    <SettingsTemplate>
      <NewSettingsItem
        actions={
          economySets.length <= 1 ? (
            <ChartOfAccounts />
          ) : (
            <Button
              onClick={() => setShowEconomySets(!showEconomySets)}
              size="small"
              variant="text"
            >
              {`${
                showEconomySets ? t('global', 'hide') : t('global', 'show')
              } ${economySets.length} ${t(
                'global',
                'chart_of_accounts',
                true
              )}`}
            </Button>
          )
        }
        helperText={t('chart_of_accounts', 'helper_text')}
        title={t('global', 'chart_of_accounts')}
      >
        {economySets.length > 1 && showEconomySets ? <ChartOfAccounts /> : null}
      </NewSettingsItem>

      <NewSettingsItem
        actions={<EconomyAccountingPeriod />}
        helperText={t('accounting', 'accounting_periods_helper_text')}
        title={t('accounting', 'accounting_periods')}
      />

      <NewSettingsItem
        actions={
          <Button
            onClick={() => setShowMetrics(!showMetrics)}
            size="small"
            variant="text"
          >
            {`${showMetrics ? t('global', 'hide') : t('global', 'show')} ${
              customKpis.length
            } ${t('metrics', 'metrics', true)}`}
          </Button>
        }
        helperText={t('economy', 'metrics_helper_text')}
        title={t('metrics', 'metrics')}
      >
        {showMetrics ? <EconomyCustomMetrics /> : null}
      </NewSettingsItem>

      {/* has its own NewSettingsItems */}
      <EconomyAccountLevels />
    </SettingsTemplate>
  )
}

export default EconomyPage
